import { useModal } from "@surveying-hub-bv/fe-component-library"
import { Button } from "../../../components/Buttons"
import { AlertIcon } from "../../../components/ContentElements"

export const GenericPaymentDetailsErrorDialog = () => {
    const { hideModal } = useModal()    

    return (
        <div className="modal-content">
            <AlertIcon type="error" />
            <h3 className="modal-title text-center">Could Not Retrieve Billing Details</h3>
            <p className="text-gray-400 text-center mb-2">An error occurred while retrieving your billing information. Please refresh the page and try again.</p>
            <div className="modal-footer-actions">
                <Button label="Close" onClick={hideModal} buttonStyle="muted" alwaysFullWidth />
            </div>
        </div>

    )
}